module.exports = __webpack_public_path__ + "static/media/send-message.6b6b1c5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/send-message.svg
// module id = 1875
// module chunks = 0